"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadBinding = void 0;
var loader_1 = require("./loader");
Object.defineProperty(exports, "loadBinding", { enumerable: true, get: function () { return loader_1.loadBinding; } });
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsbUNBQXNDO0FBQTdCLHFHQUFBLFdBQVcsT0FBQSJ9